'use client';

import React from 'react';

import type { TimeChartItem } from 'src/types/chart';
import type { Resolution } from '@blockscout/stats-types';

import ChartWidgetGraph from './ChartWidgetGraph';

import styles from './ChartWidgetContent.module.css';

export type Props = {
  items?: Array<TimeChartItem>;
  title: string;
  units?: string;
  isLoading?: boolean;
  isError?: boolean;
  emptyText?: string;
  zoomRange?: [Date, Date];
  handleZoom: (range: [Date, Date]) => void;
  isEnlarged?: boolean;
  noAnimation?: boolean;
  resolution?: Resolution;
};

const ChartWidgetContent = ({
  items,
  title,
  isLoading,
  isError,
  units,
  emptyText,
  zoomRange,
  handleZoom,
  isEnlarged,
  noAnimation,
  resolution,
}: Props) => {
  const hasItems = items && items.length > 2;

  if (isError) {
    return (
      <div className={ styles.message }>
        <p>The data didn&apos;t load. Please, <a href={ typeof window !== 'undefined' ? window.document.location.href : '#' }>try to reload the page.</a></p>
      </div>
    );
  }

  if (isLoading) {
    return <div className={ styles.skeleton } />;
  }

  if (!hasItems) {
    return (
      <div className={ styles.message }>
        <p>{ emptyText || 'No data' }</p>
      </div>
    );
  }

  return (
    <div className={ styles.graphContainer }>
      <ChartWidgetGraph
        items={ items }
        zoomRange={ zoomRange }
        onZoom={ handleZoom }
        title={ title }
        units={ units }
        isEnlarged={ isEnlarged }
        noAnimation={ noAnimation }
        resolution={ resolution }
      />
    </div>
  );
};

export default React.memo(ChartWidgetContent);
